import styled, { css } from 'styled-components';

import { device } from '@/styles/helpers';

export const ScActionsPanel = styled.div<{
  isFullScreen: boolean;
}>`
  position: absolute;
  left: 100%;
  top: 0;
  bottom: 0;
  transform: translateX(0%);
  background-color: ${({ theme }) => theme.blackColor};
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ isFullScreen }) => (isFullScreen ? '0 8px' : '0 0 0 16px')};

  ${({ isFullScreen }) =>
    !isFullScreen &&
    css`
      @media (${device.mobile}) {
        height: 100%;
      }
    `}

  & > * {
    margin-bottom: 8px;
  }

  & > .btn__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    position: relative;
    background-color: ${({ theme }) => theme.grayLightColor};
    border-radius: 50%;

    &.btn__close {
      margin-bottom: 24px;
    }
  }

  .toggle__wrapper {
    position: relative;
  }
`;
